/* ==========================================================================
   ASAP Care — shared Bundle & Save + free-gift logic
   One script for every product page and the cart page. Reads its rules from
   the JSON written by snippets/bundle-offer.liquid; nothing is product-specific.

   Prices shown here are a preview. The real discount comes from Shopify
   automatic discounts at cart/checkout; the gift's R0.00 comes from a Shopify
   Buy X Get Y automatic discount. This script only (a) adds the right
   variant + quantity and (b) keeps exactly one gift line in the cart while the
   cart actually qualifies.
   ========================================================================== */
(function () {
  'use strict';

  var GIFT_FOR = '_bundle_gift_for';   // on the gift line
  var GIFT_ID = '_bundle_gift';        // on the qualifying product line
  var GIFT_MIN = '_bundle_gift_min';
  var GIFT_STARTS = '_bundle_gift_starts';
  var GIFT_ENDS = '_bundle_gift_ends';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------------- money ---------------- */
  function formatMoney(cents, format) {
    cents = Math.round(Number(cents) || 0);
    format = format || window.themeMoneyFormat || 'R {{amount}}';
    function withDelims(n, precision, thousands, decimal) {
      var fixed = (n / 100).toFixed(precision);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts[1] ? parts[0] + decimal + parts[1] : parts[0];
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals': value = withDelims(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelims(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelims(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = withDelims(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelims(cents, 2, "'", '.'); break;
      default: value = withDelims(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }
  window.asapFormatMoney = formatMoney;

  function bundleTotal(unitCents, qty, percent) {
    var regular = unitCents * qty;
    var final = Math.round(regular * (100 - percent) / 100);
    return { regular: regular, final: final, saved: regular - final };
  }

  /* ---------------- cart API ---------------- */
  function postJSON(url, body) {
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }
  function getCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function declinedKey(id) { return 'asapGiftDeclined:' + id; }
  function isDeclined(id) { try { return sessionStorage.getItem(declinedKey(id)) === '1'; } catch (e) { return false; } }
  function setDeclined(id, v) {
    try { if (v) sessionStorage.setItem(declinedKey(id), '1'); else sessionStorage.removeItem(declinedKey(id)); } catch (e) {}
  }

  /* Decide which gifts the cart qualifies for and make the cart match:
     exactly one gift line (qty 1) per qualifying gift, none otherwise.
     Resolves to true when the cart was changed. */
  function syncGifts(cart) {
    var now = Date.now();
    var sums = {};      // giftId|productId -> qty
    var mins = {};      // giftId -> min qty
    var triggers = {};  // giftId -> a qualifying variant id
    cart.items.forEach(function (item) {
      var p = item.properties || {};
      if (p[GIFT_FOR] || !p[GIFT_ID]) return;
      var starts = Number(p[GIFT_STARTS]) || 0;
      var ends = Number(p[GIFT_ENDS]) || 0;
      if (starts && now < starts * 1000) return;
      if (ends && now >= ends * 1000) return;
      var gid = String(p[GIFT_ID]);
      var k = gid + '|' + item.product_id;
      sums[k] = (sums[k] || 0) + item.quantity;
      mins[gid] = Number(p[GIFT_MIN]) || 3;
      if (sums[k] >= mins[gid]) triggers[gid] = item.variant_id;
    });

    var updates = {};
    var seen = {};
    var changed = false;
    cart.items.forEach(function (item) {
      var p = item.properties || {};
      if (!p[GIFT_FOR]) return;
      var gid = String(item.variant_id);
      if (!triggers[gid] || seen[gid]) { updates[item.key] = 0; changed = true; return; }
      seen[gid] = true;
      if (item.quantity !== 1) { updates[item.key] = 1; changed = true; }
    });

    var adds = [];
    Object.keys(triggers).forEach(function (gid) {
      if (seen[gid] || isDeclined(gid)) return;
      var props = {};
      props[GIFT_FOR] = String(triggers[gid]);
      adds.push({ id: Number(gid), quantity: 1, properties: props });
    });
    // A gift the shopper removed stays removed only while they still qualify.
    Object.keys(mins).forEach(function (gid) { if (!triggers[gid]) setDeclined(gid, false); });

    var chain = Promise.resolve();
    if (Object.keys(updates).length) chain = chain.then(function () { return postJSON('cart/update.js', { updates: updates }); });
    if (adds.length) {
      changed = true;
      chain = chain.then(function () {
        return postJSON('cart/add.js', { items: adds }).catch(function (err) {
          // Gift out of stock etc. — never block the customer's own purchase.
          console.warn('[bundle] gift could not be added', err);
        });
      });
    }
    return chain.then(function () { return changed; });
  }

  window.AsapBundles = { syncGifts: syncGifts, getCart: getCart, formatMoney: formatMoney, declineGift: function (id) { setDeclined(String(id), true); } };

  /* ======================= PRODUCT PAGE ======================= */
  function initProductPage() {
    var form = document.getElementById('product-form');
    if (!form) return;
    var cfgEl = document.querySelector('[data-bundle-config]');
    var cfg = { enabled: false };
    try { if (cfgEl) cfg = JSON.parse(cfgEl.textContent); } catch (e) { cfg = { enabled: false }; }

    var variantSelect = form.querySelector('[data-variant-select]');
    var block = document.querySelector('[data-bundle-block]');
    var cards = block ? Array.prototype.slice.call(block.querySelectorAll('[data-bundle-card]')) : [];
    var qtyInput = document.getElementById('quantityInput');
    var qtyValue = document.getElementById('qtyValue');
    var qtyMinus = document.getElementById('qtyMinus');
    var qtyPlus = document.getElementById('qtyPlus');
    var tiers = (cfg.enabled && cfg.tiers) ? cfg.tiers.slice().sort(function (a, b) { return a.qty - b.qty; }) : [{ qty: 1, percent: 0 }];
    var state = { qty: 1 };

    function currentOption() {
      if (!variantSelect) return null;
      return variantSelect.options[variantSelect.selectedIndex] || null;
    }
    function unitPrice() {
      var o = currentOption();
      return o ? parseInt(o.getAttribute('data-price'), 10) || 0 : 0;
    }
    function stockLimit() {
      var o = currentOption();
      if (!o) return Infinity;
      if (o.getAttribute('data-available') !== 'true') return 0;
      var inv = o.getAttribute('data-inventory');
      return inv === '' || inv === null ? Infinity : Math.max(0, parseInt(inv, 10) || 0);
    }
    function tierFor(qty) {
      var t = tiers[0];
      tiers.forEach(function (x) { if (qty >= x.qty) t = x; });
      return t;
    }
    function giftActive() {
      var g = cfg.enabled && cfg.gift;
      if (!g) return false;
      var now = Date.now();
      if (g.startsAt && now < g.startsAt * 1000) return false;
      if (g.endsAt && now >= g.endsAt * 1000) return false;
      return true;
    }

    function render() {
      var unit = unitPrice();
      var limit = stockLimit();
      var activeTier = tierFor(state.qty);

      cards.forEach(function (card) {
        var q = parseInt(card.getAttribute('data-bundle-qty'), 10);
        var pct = parseInt(card.getAttribute('data-bundle-percent'), 10) || 0;
        var t = bundleTotal(unit, q, pct);
        var now = card.querySelector('[data-bundle-price]');
        var was = card.querySelector('[data-bundle-was]');
        var save = card.querySelector('[data-bundle-save]');
        if (now) now.textContent = formatMoney(Math.round(t.final / q)) + (q > 1 ? ' each' : '');
        if (was) was.textContent = formatMoney(unit);
        if (save) save.textContent = (q > 1 ? 'Total ' + formatMoney(t.final) + ' · ' : '') + 'You save ' + formatMoney(t.saved);

        var outOfStock = q > limit;
        var input = card.querySelector('input');
        card.classList.toggle('is-disabled', outOfStock);
        card.setAttribute('aria-disabled', outOfStock ? 'true' : 'false');
        if (input) input.disabled = outOfStock;
        var msg = card.querySelector('[data-bundle-stock-msg]');
        if (msg) {
          msg.hidden = !(outOfStock && limit > 0);
          if (limit > 0) msg.textContent = 'Only ' + limit + ' left';
        }
        // Never advertise "Most popular" / a gift on an option that can't be bought.
        var badge = card.querySelector('[data-bundle-badge]');
        if (badge) badge.hidden = outOfStock;

        var selected = (activeTier.qty === q);
        card.classList.toggle('is-selected', selected);
        if (input) input.checked = selected;
      });

      var total = bundleTotal(unit, state.qty, activeTier.percent);
      if (qtyInput) qtyInput.value = state.qty;
      if (qtyValue) qtyValue.textContent = state.qty;
      if (qtyMinus) qtyMinus.disabled = state.qty <= 1;
      if (qtyPlus) qtyPlus.disabled = state.qty >= limit;
      document.querySelectorAll('[data-btn-price], [data-btn-price-mobile]').forEach(function (el) {
        el.textContent = formatMoney(total.final);
      });
    }

    function setQty(q) {
      var limit = stockLimit();
      q = Math.max(1, Math.floor(q) || 1);
      if (limit !== Infinity && limit > 0) q = Math.min(q, limit);
      state.qty = q;
      render();
    }

    /* Default = configured tier (Buy 2) when it exists and is in stock;
       otherwise the largest valid tier below it; otherwise Buy 1. */
    function applyDefault() {
      var limit = stockLimit();
      var want = cfg.enabled ? (parseInt(cfg.defaultTier, 10) || 1) : 1;
      var pick = 1;
      tiers.forEach(function (t) { if (t.qty <= want && t.qty <= limit) pick = Math.max(pick, t.qty); });
      state.qty = pick;
      render();
    }

    cards.forEach(function (card) {
      var input = card.querySelector('input');
      function choose(e) {
        if (card.classList.contains('is-disabled')) { if (e) e.preventDefault(); return; }
        setQty(parseInt(card.getAttribute('data-bundle-qty'), 10));
      }
      if (input) input.addEventListener('change', choose);
      card.addEventListener('click', function (e) {
        if (e.target === input) return; // label click already fires change
        if (card.classList.contains('is-disabled')) e.preventDefault();
      });
    });

    if (qtyMinus) qtyMinus.addEventListener('click', function () { setQty(state.qty - 1); });
    if (qtyPlus) qtyPlus.addEventListener('click', function () { setQty(state.qty + 1); });

    document.addEventListener('asap:variant-change', function () {
      // keep the shopper's chosen quantity if the new variant can supply it
      var limit = stockLimit();
      if (state.qty > limit) applyDefault(); else render();
    });

    function buildItems() {
      var o = currentOption();
      var id = o ? Number(o.value) : null;
      if (!id) return null;
      var items = [];
      var props = {};
      if (cfg.enabled && giftActive()) {
        props[GIFT_ID] = String(cfg.gift.variantId);
        props[GIFT_MIN] = String(cfg.gift.minQty);
        if (cfg.gift.startsAt) props[GIFT_STARTS] = String(cfg.gift.startsAt);
        if (cfg.gift.endsAt) props[GIFT_ENDS] = String(cfg.gift.endsAt);
      }
      items.push({ id: id, quantity: state.qty, properties: props });
      return items;
    }

    function addToCart(button, destination) {
      var items = buildItems();
      if (!items || (button && button.disabled)) return;
      var original = button ? button.innerHTML : '';
      if (button) { button.disabled = true; button.textContent = 'Adding…'; }
      postJSON('cart/add.js', { items: items })
        .then(function () { return getCart(); })
        .then(function (cart) { return syncGifts(cart); })
        .then(function () { window.location.href = root + destination; })
        .catch(function (err) {
          if (button) { button.disabled = false; button.innerHTML = original; render(); }
          showError((err && (err.description || err.message)) || 'Could not add this item to your cart. Please try again.');
        });
    }

    function showError(text) {
      var box = form.querySelector('[data-cart-error]');
      if (!box) {
        box = document.createElement('p');
        box.className = 'bundle-error';
        box.setAttribute('data-cart-error', '');
        box.setAttribute('role', 'alert');
        var cta = form.querySelector('.cta-row');
        (cta ? cta.parentNode : form).insertBefore(box, cta ? cta.nextSibling : null);
      }
      box.textContent = text;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCart(form.querySelector('[data-add-to-cart]'), 'cart');
    });
    var buyNow = document.querySelector('[data-buy-now]');
    if (buyNow) buyNow.addEventListener('click', function () { addToCart(buyNow, 'checkout'); });
    var mobileAdd = document.querySelector('[data-add-to-cart-mobile]');
    if (mobileAdd) mobileAdd.addEventListener('click', function (e) { e.preventDefault(); addToCart(mobileAdd, 'cart'); });

    applyDefault();
  }

  /* ======================= CART PAGE ======================= */
  function initCartPage() {
    var wrap = document.querySelector('[data-cart-items]');
    if (!wrap) return;
    // Remember when a shopper deliberately removes their gift.
    wrap.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-cart-remove]');
      if (!rm) return;
      var row = rm.closest('[data-gift-line]');
      if (row) setDeclined(row.getAttribute('data-variant-id'), true);
    }, true);
    // Re-check on load (offer may have ended, quantities changed elsewhere).
    getCart().then(syncGifts).then(function (changed) { if (changed) window.location.reload(); })
      .catch(function (e) { console.warn('[bundle] gift sync failed', e); });
  }

  function init() { initProductPage(); initCartPage(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
